"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const react_i18next_1 = require("react-i18next");
const FavoriteButton_1 = __importDefault(require("./FavoriteButton"));
const content_1 = require("../../../server/models/content");
const recoil_1 = require("recoil");
const Toast_1 = require("../Toast/Toast");
const FavoriteContentButton = ({ elementType, contentMetadataId, liked, handleOnDeleteFavorite, contentFavoriteId, t, }) => {
    const [toastProps, setToastProps] = (0, recoil_1.useRecoilState)(Toast_1.showToastState);
    const addMessage = `${elementType?.charAt(0).toUpperCase()}${elementType
        ?.slice(1)
        .toLowerCase()} ${t('favoriteAdd', { ns: 'ModalWindow' })}`;
    const removeMessage = `${elementType?.charAt(0).toUpperCase()}${elementType
        ?.slice(1)
        .toLowerCase()} ${t('favoriteRemove', { ns: 'ModalWindow' })}`;
    const errorMessage = `${t('favoriteError', {
        ns: 'ModalWindow',
    })} ${elementType}. ${t('pleaseTryAgain', { ns: 'ModalWindow' })}`;
    const handleFavouriteContent = async (liked) => {
        if (liked) {
            (0, content_1.createContentFavorite)({
                contentMetadataId: contentMetadataId,
            })
                .then((res) => {
                contentFavoriteId = res?.id;
                setToastProps({
                    ...toastProps,
                    showToast: true,
                    severity: 'success',
                    message: addMessage,
                });
                return true;
            })
                .catch(() => {
                setToastProps({
                    ...toastProps,
                    showToast: true,
                    severity: 'error',
                    message: errorMessage,
                });
                return false;
            });
        }
        if (!liked && contentFavoriteId) {
            (0, content_1.deleteContentFavorite)(contentFavoriteId).then(() => handleOnDeleteFavorite(contentFavoriteId));
            setToastProps({
                ...toastProps,
                showToast: true,
                severity: 'success',
                message: removeMessage,
            });
        }
    };
    return (react_1.default.createElement(FavoriteButton_1.default, { liked: liked, onFavourite: handleFavouriteContent, "aria-label": t('favorites', { ns: 'AriaLabels' }) }));
};
exports.default = (0, react_i18next_1.withTranslation)(['ModalWindow', 'AriaLabels'])(FavoriteContentButton);
